import React from 'react';

import styles from './newAllocatorStyles.scss';

import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import CardFeed from '@buyside/components/presentation/CardFeed/cardFeed';
import FundRecommendationHeader from '@buyside/components/presentation/Feed/FundRecommendationHeader/fundRecommendationHeader';
import Link, { LINK_TYPES } from '@buyside/components/presentation/Link/link';
import NewAllocatorAnonymous from '@buyside/components/presentation/Feed/NewAllocatorAnonymous/newAllocatorAnonymous';

import PieChartIcon from '@buyside/svgs/pie_chart.svg';

import { allocatorProfileUrl } from '@buyside/util/urlHelper';
import {
  ActivityFeedAllocatorProfileFragment,
  AllocatorProfileCardFragment,
  AllocatorProfileRecommendationFragment
} from '@interfaces/graphql-typings';

const NewAllocator: React.FC<{
  allocator: ActivityFeedAllocatorProfileFragment;
  recommendation: AllocatorProfileRecommendationFragment;
  recommendedAllocatorProfile: AllocatorProfileCardFragment;
}> = ({ allocator, recommendation, recommendedAllocatorProfile }) => {
  const {
    vanityLink,
    name,
    undisclosed,
    aumRange,
    employerType,
    location,
    fundManager,
    bio
  } = allocator;

  if (!name) {
    return <NewAllocatorAnonymous allocator={allocator} />;
  }

  const displayFundManagerName = (name?: string): string => {
    if (!name) return 'N/A';
    if (name.length > 14) {
      return name.slice(0, 14).trim() + '...';
    } else {
      return name;
    }
  };

  return (
    <div className={styles.newAllocator}>
      {vanityLink && (
        <p>
          <Link to={allocatorProfileUrl(vanityLink)}>{name}</Link>
          &nbsp;has joined SumZero as a Capital Allocator
        </p>
      )}
      {recommendation && (
        <FundRecommendationHeader
          fundRecommendation={recommendation}
          recommendedAllocatorProfile={recommendedAllocatorProfile}
        />
      )}
      <CardFeed type={'secondary'}>
        <div className={styles.cardInner}>
          <div className={styles.header}>
            <PieChartIcon className={styles.pieChartIcon} />
            <h3>
              {vanityLink && (
                <Link to={allocatorProfileUrl(vanityLink)} type={LINK_TYPES.PLAIN}>
                  {name}
                </Link>
              )}
            </h3>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailRowItem}>
              <strong>Aum:</strong> {aumRange && !undisclosed ? aumRange : 'Withheld'}
            </span>
            <span className={styles.detailRowItem}>
              <strong>Type:</strong> {employerType ? employerType : 'N/A'}
            </span>
            {fundManager && (
              <span className={styles.detailRowItem}>
                <strong>Managed By:</strong> {displayFundManagerName(fundManager)}
              </span>
            )}
            <span className={styles.detailRowItem}>
              <strong>Location:</strong> {location ? location : 'N/A'}
            </span>
          </div>
          {bio && <blockquote>{bio.slice(0, 300) + '...'}</blockquote>}
          {vanityLink && (
            <Button
              type={BUTTON_TYPES.PRIMARY}
              icon={PieChartIcon}
              text="View Allocator"
              url={allocatorProfileUrl(vanityLink)}
            />
          )}
        </div>
      </CardFeed>
    </div>
  );
};

export default NewAllocator;
